import { installIosShortViewport } from "@/lib/iosShortViewport.ts";
import { installIosFocusPan } from "@/lib/iosFocusPan.ts";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { installIosDownloads } from "./lib/iosDownloads.ts";
import "./app.css";
import "./i18n/index.ts";
import { applyLocale, readLocale } from "./i18n/index.ts";
import { applyTheme, readTheme, watchSystemTheme } from "./lib/theme.ts";
import { queryClient } from "./queryClient.ts";
import { router } from "./router.tsx";
import { registerSw } from "./lib/push.ts";
import { ConfirmProvider } from "./ui/ConfirmDialog.tsx";
import { ImageViewerProvider } from "./ui/ImageViewer.tsx";

applyTheme(readTheme());
applyLocale(readLocale());
watchSystemTheme();
void registerSw();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfirmProvider>
        <ImageViewerProvider>
          <RouterProvider router={router} />
        </ImageViewerProvider>
      </ConfirmProvider>
    </QueryClientProvider>
  </StrictMode>,
);

// Installed app (home screen) and notifications both rely on the service worker: register it on every load.
installIosDownloads();
installIosShortViewport();
installIosFocusPan();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => undefined);
  });
}
